import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    MenuItem,
    TextField,
    Typography
} from '@mui/material';
import { FormEvent, useState } from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import t from '../../../theme';
import { ConfigurableItemDto } from '../../ListItem';
import { useGet } from '../../../lib/api/hooks';
import { AncillaryHourModel, EditAncillaryHourModel } from '../../../lib/models/AncillaryHourModel';
import { cancelButtonStyle, saveButtonStyle } from '../../../style';
import { useScreenSmallerThan } from '../../../lib/hooks/breakpoint-hooks';
interface ModalProps {
    ancillaryHour: AncillaryHourModel;
    onEditAncillaryHour: (event: FormEvent, edidAncillaryHour: EditAncillaryHourModel) => void;
}

const EditAncillaryHourModal = ({ ancillaryHour, onEditAncillaryHour }: ModalProps) => {
    const isSmallerThanSmall = useScreenSmallerThan('sm');
    const { id, minutesTaken } = ancillaryHour;
    const name = encodeURIComponent('How long did it take?');
    const { data } = useGet<ConfigurableItemDto[]>(`appconfigs/by-name/${name}`);
    const [isDialogOpened, setDialogOpened] = useState(false);
    const [minutesValue, setMinutesValue] = useState(minutesTaken.toString());
    const [notes, setNotes] = useState(ancillaryHour.notes);
    const oldValue = minutesTaken;
    const handleCloseDialog = () => setDialogOpened(false);
    const handleOpenDialog = () => setDialogOpened(true);

    const handleSave = async (event: FormEvent) => {
        event.preventDefault();
        const updatedAncillaryHour: EditAncillaryHourModel = {
            id: id,
            minutesTaken: parseInt(minutesValue),
            notes: notes,
            oldValue: oldValue,
            modifiedAt: new Date()
        };

        onEditAncillaryHour(event, updatedAncillaryHour);

        //Close Dialog window
        setDialogOpened(false);
    };

    return (
        <>
            <IconButton aria-label="edit" onClick={handleOpenDialog} disableRipple={true}>
                <EditOutlinedIcon
                    sx={{
                        color: t.palette.primary.main
                    }}
                />
                {isSmallerThanSmall && <Typography pl={'0.525rem'}>Edit</Typography>}
            </IconButton>

            <Dialog open={isDialogOpened} onClose={handleCloseDialog}>
                <DialogTitle variant="h3">Edit Ancillary Hours</DialogTitle>
                <form>
                    <DialogContent sx={{ paddingTop: 0 }}>
                        <FormControl size="small" fullWidth>
                            <Typography
                                variant="h5"
                                sx={{ color: t.palette.cardSubtitle.main, fontWeight: 500 }}>
                                Minutes
                            </Typography>
                            <TextField
                                select
                                autoFocus
                                margin="dense"
                                fullWidth
                                variant="outlined"
                                type="number"
                                value={minutesValue}
                                onChange={(v) => setMinutesValue(v.target.value)}>
                                {data?.map((itme, index) => (
                                    <MenuItem key={index} value={itme.value}>
                                        {itme.value} minutes
                                    </MenuItem>
                                ))}
                            </TextField>
                        </FormControl>
                        <FormControl size="small" fullWidth sx={{ marginTop: '0.313rem' }}>
                            <Typography
                                variant="h5"
                                sx={{
                                    color: t.palette.cardSubtitle.main,
                                    fontWeight: 500,
                                    mb: '0.313rem'
                                }}>
                                Notes
                            </Typography>
                            <TextField
                                id="ancillary-hours-notes"
                                multiline
                                minRows={2}
                                placeholder="Optional"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                            />
                        </FormControl>
                    </DialogContent>
                    <DialogActions sx={{ paddingRight: '1.5rem', paddingLeft: '1.5rem' }}>
                        <Button sx={cancelButtonStyle} onClick={handleCloseDialog}>
                            Cancel
                        </Button>
                        <Button sx={saveButtonStyle} onClick={handleSave}>
                            Save
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
};

export default EditAncillaryHourModal;
